












import { Component, Prop, Vue } from 'vue-property-decorator';
import IconComponent from '@/modules/business-plan/common/utils/icon.component.vue';

@Component({
    name: 'InfoComponent',
    components: { IconComponent },
})
export default class InfoComponent extends Vue {
    @Prop({ required: true })
    public name: string;

    @Prop()
    public marginTop: string;

    @Prop()
    public width: string;

    public marginTopInternal: string = '-120px';
    public widthInternal: string = '320px';

    public hoverShowInfo() {
        this.$nextTick(() => {
            const info: any = document.querySelector(`[data-title="${this.name}"]`)
            info.style.display = 'block';
        });
    }

    public leaveShowInfo() {
        this.$nextTick(() => {
            const info: any = document.querySelector(`[data-title="${this.name}"]`)
            info.style.display = 'none';
        });
    }

    public mounted() {
      if (this.marginTop) {
        this.marginTopInternal = this.marginTop;
      }

      if (this.width) {
        this.widthInternal = this.width;
      }
    }
}
